import {
  APP_MEDICAL_BODIES_REQUEST,
  APP_MEDICAL_BODIES_RESPONSE,
  APP_MEDICAL_BODIES_FAILURE,
  APP_MEDICAL_BODIES_UPDATE_FILTERS,
} from "../../../actions/types";
import { getOptions } from "../expertSummary";

const initialState = {
  isFetching: false,
  error: false,
  results: [],
  total: 0,
  filters: {
    from: 0,
    size: 25,
    activePage: 1,
    sorting: { key: "PATIENT_GROUPS_AND_MEDICAL_SOCIETIES", order: "asc" },
    PATIENT_GROUPS_AND_MEDICAL_SOCIETIES: "",
    COUNTRY: "",
    CONDITION: "",
    queryText: "",
    EXPERTS: ""
  },
};

const setFetching = (state, action) => {
  const { filters } = action.payload;

  return {
    ...state,
    isFetching: true,
    filters,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    total: 0,
  };
};

const setResults = (state, action) => {
  const { results, total } = action.payload;

  /**
   * add filter options here
   */
   let filters = state.filters || {};
   let nameMapping = {
   };
   let keyMapping = {
   };
   let optionsKeys = ['COUNTRY', 'PATIENT_GROUPS_AND_MEDICAL_SOCIETIES', 'CONDITION'];
   optionsKeys.forEach(l => {
     let optionsInfo = getOptions(results, l, nameMapping, action.payload);
     Object.keys(keyMapping).forEach(key => {
        if(optionsInfo[`${key}Options`]){
          optionsInfo[`${keyMapping[key]}Options`] = optionsInfo[`${key}Options`]
        }
     });

     if(l === 'COUNTRY'){
      optionsInfo[`COUNTRYOptions`] = optionsInfo[`COUNTRYOptions`].map(l => l.toUpperCase())
    }
    
     filters = {
       ...filters,
       ...optionsInfo,
     }   

   });


  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    total,
    filters
  };
};

const updateFilters = (state, action) => {
  const { filters } = action.payload;

  return {
    ...state,
    filters,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_MEDICAL_BODIES_REQUEST:
      return setFetching(state, action);

    case APP_MEDICAL_BODIES_RESPONSE:
      return setResults(state, action);

    case APP_MEDICAL_BODIES_FAILURE:
      return setFailure(state, action);

    case APP_MEDICAL_BODIES_UPDATE_FILTERS:
      return updateFilters(state, action);

    default:
      return state;
  }
};
